import { render, staticRenderFns } from "./IdentificationNumberInput.vue?vue&type=template&id=65d5158f"
import script from "./IdentificationNumberInput.vue?vue&type=script&lang=js"
export * from "./IdentificationNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports